import {
  Button,
  Divider,
  Grid,
  InputBase,
  Radio,
  Switch,
  Typography,
} from "@material-ui/core";
import { Add, Search } from "@material-ui/icons";
import React, { Component } from "react";
import { connect } from "react-redux";
import { navigate } from "../../actions/routerResolve";
import { constants } from "../../config";
import { colors, metrics } from "../../styles";

import { msgAction, msgSimple } from "../../actions/snackbarActions";
import DialogSearch from "./DialogSearch";

class OptionsBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      widthInput: 7,
      searchOption: "",
      user: "",
      role: JSON.parse(localStorage.getItem(constants.userKey)).user.profile,
    };
  }

  handleChange = (event) => {
    if (event) {
      if (this.state.searchOption === event.target.value) {
        this.setState({ searchOption: "" });
        this.props.handleRefresh();
      } else {
        this.setState({ searchOption: event.target.value });
        if (event.target.value === "f")
          this.props.handleSearchByStatus("Finalizado");
        else if (event.target.value === "a")
          this.props.handleSearchByStatus("Em andamento");
        else if (event.target.value === "g")
          this.props.handleSearchByStatus("Confirmado");
      }
    } else {
      this.setState({ searchOption: "" });
      this.props.handleRefresh();
    }
  };

  render() {
    return (
      <div style={{ width: "100%" }}>
        <Grid
          container
          style={{
            ...styles.container,
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <DialogSearch
            openSearch={this.props.openSearch}
            handleOpenDialog={this.props.handleOpenDialog}
            handleCustomSearch={this.props.handleCustomSearch}
          />
          <Grid item xs={1.5}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <Typography>Calendário:</Typography>

              <Switch
                color="primary"
                defaultChecked={this.props.viewCalendar === "calendar"}
                onChange={this.props.handleChangeSwitch}
              />
            </div>
          </Grid>
          <Grid
            md={2.5}
            item
            justifyContent="center"
            alignItems="center"
            style={{
              backgroundColor: "#f5f5f5",
              borderRadius: 6,
              padding: 2,
              color: colors.white,
            }}
          >
            <InputBase
              autoFocus={false}
              onKeyDown={(event) => {
                if (event.key == "Enter") {
                  if (this.state.search)
                    this.props.handleSearch(this.state.search);
                  else this.props.handleRefresh();
                }
                //         this.handleSearch(this.state.search)
              }}
              onFocus={() => this.setState({ widthInput: 12 })}
              onBlur={() => this.setState({ widthInput: 7 })}
              placeholder="Pesquisar"
              onChange={(event) => {
                this.setState({ search: event.target.value });
              }}
              style={{ width: "100%", color: colors.black }}
              startAdornment={<Search style={{ paddingRight: 5 }} />}
            />
          </Grid>
          <Grid
            md={5}
            item
            container
            direction={"row"}
            justify={"flex-end"}
            style={{ paddingTop: 0, marginTop: 0 }}
          >
            {this.state.role === "Administração" && (
              <Grid item md={6}>
                <Radio
                  name="search"
                  style={{ color: colors.primary_darker }}
                  checked={this.state.searchOption === "a"}
                  value={"a"}
                  onChange={this.handleChange}
                  onClick={this.handleChange}
                />
                <span style={{ fontSize: 12 }}>Voos em Andamento</span>
              </Grid>
            )}
            {/* {this.state.role === "Administração" && (<Grid item md={4}>
                  <Radio
                    name="search"
                    style={{ color: colors.primary_darker }}
                    checked={this.state.searchOption === "g"}
                    value={"g"}
                    onChange={this.handleChange}
                    onClick={this.handleChange}
                  />
                  <span style={{ fontSize: 12 }}>Voos Confirmados</span>
                </Grid>)} */}
            <Grid item md={this.state.role === "Administração" ? 6 : 12}>
              <Radio
                name="search"
                style={{ color: colors.primary_darker }}
                checked={this.state.searchOption === "f"}
                value={"f"}
                onChange={this.handleChange}
                onClick={this.handleChange}
              />
              <span style={{ fontSize: 12 }}>Voos finalizados</span>
            </Grid>
          </Grid>
          <Grid item md={1.5}>
            <Button
              onClick={() => {
                if (this.props.clean) this.props.handleOpenDialog();
                else {
                  this.props.handleRefresh();
                  this.handleChange();
                }
              }}
              style={{ color: colors.primary_darker }}
            >
              {this.props.clean ? (
                <Grid container justify="center" alignItems="center">
                  <Grid item>Mais Filtros</Grid> <Add />
                </Grid>
              ) : (
                <Grid container alignItems="center">
                  <Grid item>Limpar Filtros</Grid>
                  <Add />
                </Grid>
              )}
            </Button>
          </Grid>
          <Grid item md={1.5}>
            {this.state.role != "Auxiliar de Manutenção" &&
            this.state.role != "Comissárias" &&
            this.state.role != "Passageiro" &&
            this.state.role != "Diretor de Manutenção" ? (
              <Button
                onClick={() => this.props.navigate("/new-mission/new")}
                style={{
                  backgroundColor: colors.primary_darker,
                  color: "ghostwhite",
                }}
              >
                Solicitar Novo Voo <Add />
              </Button>
            ) : null}
          </Grid>
        </Grid>
        <Divider style={{ width: "100%" }} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  users: state.usersReducer.users,
});

const mapDispatchToProps = {
  msgSimple,
  msgAction,
  navigate,
};

export default connect(mapStateToProps, mapDispatchToProps)(OptionsBar);
const styles = {
  container: {
    padding: metrics.paddingPage,
    backgroundColor: colors.white,
  },
};



// WEBPACK FOOTER //
// ./src/routes/home/OptionsBar.js